module.exports = __webpack_public_path__ + "National2Web-Light.eot?f684bd7cb1bc4de756dff599ddcabfd6";